export function filterLinksUrl() {
  return new Promise((resolve, reject) => {
    const container = document.querySelector("[data-filterLinksUrl]");
    if (!container) {
      return resolve();
    }

    let url = container.getAttribute("data-filterLinksUrl");
    if (!url) {
      return resolve();
    }

    const currentUrl = encodeURIComponent(window.location.href);
    url += (url.includes("?") ? "&" : "?") + `url=${currentUrl}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          reject("Network response was not ok");
        }
        return response.json();
      })
      .then((json) => {
        if (json.filter) {
          container.outerHTML = json.filter;
        }
        resolve();
      })
      .catch((error) => {
        console.error("Chyba při zpracování JSON odpovědi:", error);
        reject(error);
      });
  });
}
